import { memo } from "react";

import { formatters, parsers } from "@fraction/shared";

import KeyValue from "./KeyValue";
import SubmissionSection from "./SubmissionSection";

export interface PropertyInformationProps {
  property: parsers.application.Property;
}

const PropertyInformation = ({ property }: PropertyInformationProps) => (
  <SubmissionSection title="Property information">
    <KeyValue label="Address" value={formatters.property.formattedAddress(property.location)} />
    <KeyValue label="Value" value={formatters.number.getCurrencyFromNumber(property.value)} />
    <KeyValue label="Type" value={formatters.enums.FULL_PROPERTY_TYPE_MAP[property.type!]} />
    <KeyValue label="Usage" value={formatters.enums.PROPERTY_USAGE_MAP[property.usage!]} />
    <KeyValue label="Tenants in common" value={property.tenantsInCommon ? "Yes" : "No"} />
    <KeyValue
      label="Mortgage(s)"
      value={`${
        property.mortgages?.length || 0
      } mortgages totalling ${formatters.number.getCurrencyFromNumber(
        property.mortgages?.reduce((a, b) => a + (b?.balance || 0), 0) || 0
      )}`}
    />
  </SubmissionSection>
);

export default memo(PropertyInformation);
